import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'
import { LoadingScreen } from './LoadingScreen'
import type { Role } from '../lib/types'

export function RequireAuth({ roles, children }: { roles?: Role[]; children: React.ReactNode }) {
  const { me, loading } = useAuth()
  const location = useLocation()

  if (loading) return <LoadingScreen />
  if (!me) return <Navigate to="/login" state={{ from: location }} replace />
  if (roles && !roles.includes(me.role)) return <Navigate to="/" replace />
  return <>{children}</>
}
